import config from '../../config.js';
import products from '../../utils/products.js';
import fieldUtils from '../../utils/step.fields.utils.js';
import {percentageGroup} from '../../utils/step.fields.utils.js';

const secondOccupation = () => {
    return [
        {
            key: `occupation_1_type`,
        },
        {
            key: `occupation_1_full_time`,
        },
    ];
};

const claims = (driver, n) => {
    const result = [
        {...fieldUtils.claim_x_type(driver, n)},
        {...fieldUtils.claim_x_date(driver, n)},
    ];

    if (n < config[products.motor_trade].claims) {
        result.push({
            ...fieldUtils.claim_x_more(driver, n),
            children: claims(driver, n + 1),
            required_children: value => value === true,
        });
    }
    return result;
};
const convictions = (driver, n) => {
    const result = [
        {...fieldUtils.conviction_x_type(driver, n)},
        {...fieldUtils.conviction_x_points(driver, n)},
        {...fieldUtils.conviction_x_ban(driver, n)},
    ];

    if (n < config[products.motor_trade].mot_convictions) {
        result.push({
            ...fieldUtils.conviction_x_more(driver, n),
            children: convictions(driver, n + 1),
            required_children: value => value === true,
        });
    }
    return result;
};

const step_schema_motor_trade = [
    // Company
    {
        key: 'company_name',
        percentage_group: percentageGroup.PERCENTAGE_COMPANY,
    },
    {
        key: 'company_age',
        percentage_group: percentageGroup.PERCENTAGE_COMPANY,
    },
    {
        key: 'motor_trade_from',
        label: 'Where do you trade from?',
        headline: fieldUtils.headlines.companyHeadline,
        children: [
            {
                key: 'business_postcode',
                required_if: parent_value => parent_value === 'trading from business',
                headline: fieldUtils.headlines.companyHeadline,
                percentage_group: percentageGroup.PERCENTAGE_COMPANY,
            },
        ],
        percentage_group: percentageGroup.PERCENTAGE_COMPANY,
    },
    {
        key: 'motor_trade_types',
        extra_children: [
            {key: 'premises_cover', label: 'Premises'},
            {key: 'motor_trade_recovery', label: 'Recovery'},
            {key: 'motor_trade_delivery', label: 'Delivery'},
            {key: 'motor_trade_park', label: 'Car Park'},
            {key: 'motor_trade_valeting', label: 'Valeting'},
            {key: 'motor_trade_body_shop', label: 'Body Shop'},
            {key: 'motor_trade_repairs', label: 'Repairs'},
            {key: 'motor_trade_mot', label: 'MOT'},
            {key: 'motor_trade_service', label: 'Trade Service'},
            {key: 'motor_trade_buy_sell', label: 'Buy & Sell'},
            {key: 'motor_trade_scrap', label: 'Scrap'},
            {key: 'caravan_park', label: 'Caravan Park'},
        ],
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    // Policy
    {
        key: 'ncb_years_motor_trade',
        headline: fieldUtils.headlines.policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    {
        key: 'ncb_years_private',
        headline: fieldUtils.headlines.policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    {
        key: 'road_use',
        headline: fieldUtils.headlines.policyHeadline,
        label: 'Do you require cover for road use?',
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    {
        key: 'value',
        label: 'What is the maximum value of any vehicle you will need to cover?',
        headline: fieldUtils.headlines.policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    {
        key: 'weight_over_75',
        label: 'Do you need cover for vehicles over 7.5 tonne?',
        headline: fieldUtils.headlines.policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    {
        key: 'kit_car',
        label: 'Do you need cover for high performance or modified vehicles?',
        headline: fieldUtils.headlines.policyHeadline,
        percentage_group: percentageGroup.PERCENTAGE_POLICY,
    },
    {
        key: 'cover_date',
    },
    {
        key: 'cover_duration',
        options: [],
    },
    {
        key: 'previous_policy_cancelled',
    },
    {
        key: 'dob_youngest_driver',
    },
    //Driver
    {
        key: 'driver_details',
        info: 'Details',
        extra_children: [
            {
                key: 'title',
                variant: 'inline'
            },
            {key: 'first_name'},
            {key: 'last_name'}
        ]
    },
    {
        key: 'telephone',
    },
    {
        key: 'email',
    },
    {
        key: 'date_of_birth',
    },
    {
        key: 'postcode',
        label: 'What is your home postcode?'
    },
    {
        key: 'address1',
        skip_question: true,
    },
    {
        key: 'address2',
        skip_question: true,
    },
    {
        key: 'address3',
        skip_question: true,
    },
    {
        key: 'address4',
        skip_question: true,
    },
    {
        key: 'city',
        skip_question: true,
    },
    {
        key: 'uk_since',
        children: [
            {
                key: 'uk_since_date',
                required_if: parent_value => parent_value === false,
            },
        ],
    },
    {
        key: 'licence_type',
    },
    {
        key: 'licence_date',
    },
    {
        key: 'occupation_0_type',
        value: 'motor trader'
    },
    {
        key: 'occupation_0_full_time',
        value: true,
    },
    {
        key: 'occupation_0_more',
        children: secondOccupation(),
        required_children: value => value === true,
    },
    {
        key: 'has_convictions_more',
        children: convictions('Proposer\'s', 0),
        required_children: value => value === true,
    },
    {
        key: 'has_claims_more',
        children: claims('Proposer\'s', 0),
        required_children: value => value === true,
    },
    {
        key: 'has_criminal_convictions',
        label: 'Do you have any unspent non-motoring convictions?'
    },
    {
        key: 'marketing',
        percentage_group: percentageGroup.PERCENTAGE_DRIVER,
        extra_children: [
            {key: 'marketing_phone'},
            {key: 'marketing_email'},
            {key: 'marketing_sms'},
        ],
    },
    {
        key: 'end',
    },
];
export default step_schema_motor_trade;
